import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import './index.css'
import App from './App.jsx'
import MentionsLegales from './pages/MentionsLegales.jsx'
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite.jsx'
import CGU from './pages/CGU.jsx'
import Signup from './pages/Signup.jsx'
import Login from './pages/Login.jsx'
import ForgotPassword from './pages/ForgotPassword.jsx'
import ResetPassword from './pages/ResetPassword.jsx'
import AuthCallback from './pages/AuthCallback.jsx'
import Pricing from './pages/pricing_component.jsx'
import Account from './pages/Account.jsx'
import Dashboard from './pages/Dashboard.jsx'
import Memory3D from './pages/Memory3D.jsx'
import PricingFree from './pages/PricingFree.jsx'
import Souvenirs from './pages/Souvenirs.jsx'
import Settings from './pages/Settings.jsx'
import Stats from './pages/Stats.jsx'
import Library from './pages/Library.jsx'
import Extension from './pages/Extension.jsx'
import DocExtension from './pages/DocExtension.jsx'
import Affiliate from './pages/Affiliate.jsx'
import AffiliateEditLink from './pages/AffiliateEditLink.jsx'
import NotFound from './pages/NotFound.jsx'
import ProtectedRoute from './components/ProtectedRoute.jsx'
import { I18nProvider } from './i18n/index.jsx'
import { TutorialProvider } from './context/TutorialContext.jsx'
import AffiliateHome from './pages/AffiliateHome.jsx'

const router = createBrowserRouter([
  { path: '/', element: <App /> },
  { path: '/ref/:code', element: <App /> }, // Route referral - redirige vers home avec ?ref=code
  { path: '/signup', element: <Signup /> },
  { path: '/login', element: <Login /> },
  { path: '/forgot-password', element: <ForgotPassword /> },
  { path: '/reset-password', element: <ResetPassword /> },
  { path: '/auth/callback', element: <AuthCallback /> },
  { path: '/pricing', element: <Pricing /> },
  { path: '/pricing-free', element: <PricingFree /> },
  { path: '/account', element: <ProtectedRoute><Account /></ProtectedRoute> },
  { path: '/dashboard', element: <ProtectedRoute><Dashboard /></ProtectedRoute> },
  { path: '/memory-3d', element: <ProtectedRoute><Memory3D /></ProtectedRoute> },
  { path: '/souvenirs', element: <ProtectedRoute><Souvenirs /></ProtectedRoute> },
  { path: '/settings', element: <ProtectedRoute><Settings /></ProtectedRoute> },
  { path: '/stats', element: <ProtectedRoute><Stats /></ProtectedRoute> },
  { path: '/libraries', element: <ProtectedRoute><Library /></ProtectedRoute> },
  { path: '/extension', element: <ProtectedRoute><Extension /></ProtectedRoute> },
  { path: '/doc-extension', element: <DocExtension /> },
  { path: '/mentions-legales', element: <MentionsLegales /> },
  { path: '/politique-confidentialite', element: <PolitiqueConfidentialite /> },
  { path: '/cgu', element: <CGU /> },
  { path: '/affiliate', element: <Affiliate /> },
  { path: '/affiliate-edit-link', element: <AffiliateEditLink /> },
  { path: '/affiliate-home', element: <AffiliateHome /> },
  { path: '*', element: <NotFound /> },
])

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <I18nProvider>
      <TutorialProvider>
        <RouterProvider router={router} />
      </TutorialProvider>
    </I18nProvider>
  </StrictMode>,
)
